// @flow
import { darken, hsl, lighten, parseToHsl } from "polished";
import { getThemeProp } from "./themeProps";

import type { UtilThemeProps } from "../types";

/*
 * Themed color x amount darkened
 */
/**
 */
const darkenColor =
  (
    amount: number | string,
    path: string,
    defaultValue?: string,
  ): ((UtilThemeProps) => string) =>
  ({ theme }: UtilThemeProps) =>
    darken(amount, getThemeProp(theme, path, defaultValue));

/*
 * Themed color x amount lightened
 */
/**
 */
const lightenColor =
  (
    amount: number | string,
    path: string,
    defaultValue?: string,
  ): ((UtilThemeProps) => string) =>
  ({ theme }: UtilThemeProps) =>
    lighten(amount, getThemeProp(theme, path, defaultValue));

/*
 * Make a color lighter or darker in the same color family
 */
/**
 */
const changeHSL = (
  color: string,
  saturation?: number,
  lightness?: number,
  hueAdjustment: number = 0,
): string => hsl(parseToHsl(color).hue + hueAdjustment, saturation, lightness);

export { darkenColor, lightenColor, changeHSL };
